import Image from 'next/image';
import { useT } from '../../../helpers/i18n';

import Consts from '../../../helpers/class/Consts'
import FooterMenu from '../menu/FooterMenu';
import PolicyNotice from '../partials/PolicyNotice';
import LoggiaSVG from '../partials/LoggiaSVG';
import {useEffect} from "react";
import LoggiaSVGNew from '../partials/LoggiaSVGNew';

export default function FooterWithApps ( props ) {
  const t = useT();

  return (
    <footer className={'footer mt-auto ' + (props.footerPaddingClass!=null?props.footerPaddingClass:'') } style={ props.fixed ? { paddingBottom: '7.625rem' } : {}}>
      <div className={'bg-design-color pt-3 pb-3\ ' + props.footerClass}>
        <div className="container">
          <div className="row">
            <div className="d-flex flex-column col-12 col-lg-6 align-items-center align-items-lg-start text-lg-start" style={{ textAlign: 'center' }}>
            <div className="row justify-content-center justify-content-lg-start mb-3">
              {
                props.iosApp != null ?
                  <div className="d-flex justify-content-center w-auto h-auto px-1">
                    <a className="h-auto w-auto" href={props.iosApp} title="iosApp">
                      <Image
                        layout={'fixed'}
                        width={135}
                        height={40}
                        src={Consts.AppleAppSvg}
                        alt="ios_app"
                        placeholder={'blur'}
                        blurDataURL={'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                      />
                    </a>
                  </div>
                  :''
              }
              {
                props.androidApp != null ?
                  <div className="d-flex justify-content-center w-auto h-auto px-1">
                    <a className="h-auto w-auto" href={props.androidApp} title="androidApp">
                      <Image
                        layout={'fixed'}
                        width={135}
                        height={40}
                        src={Consts.AndroidAppSvg}
                        alt="android_app"
                        placeholder={'blur'}
                        blurDataURL={'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                      />
                    </a>
                  </div>
                  :''
              }
            </div>
            <div className="row w-100 m-0 mb-2 justify-content-center justify-content-lg-start">
              <FooterMenu menu={props.menu} apps={false}/>
            </div>
              {
                props.iosAppText != null ?
                  <p className="fs-11 no-margin">{props.iosAppText}</p>
                  :''
              }
              {
                props.androidAppText != null ?
                  <p className="fs-11 no-margin">{props.androidAppText}</p>
                  :''
              }
              {
                props.loggiaBadgeText != null ?
                  <p className="fs-11 no-margin">{props.loggiaBadgeText}</p>
                  :''
              }
            </div>
            <div id={'w3c_div'} className={'col-12 col-lg-6 justify-content-center justify-content-lg-end text-lg-end py-3 py-lg-0'} style={{ textAlign: 'center' }}>
              {
                // the license number sits on the line of the app badges, the copyright below it
                props.registrationNumberText != null ?
                  <p className="fs-11 d-flex align-items-center justify-content-center justify-content-lg-end mb-3" style={{ minHeight: 40 }}>
                    <span>{t('footer.license')}<span className="fw-bold">{props.registrationNumber}</span></span>
                  </p>
                  : ''
              }
              <p className={'fs-11'}>{t('footer.copyright', { year: new Date().getFullYear(), title: props.title ?? '' })}</p>
              <PolicyNotice hasPrivacyPolicy={props.hasPrivacyPolicy} hasTermsAndConditions={props.hasTermsAndConditions} />
              {/* <a id={'w3c'} href={'https://validator.w3.org/nu/?doc=' + window.location} aria-labelledby={'w3c_div'} target="_blank" rel="noreferrer" title={'w3c'} style={{ width: 56, height: 20 }}>
                <Image
                  layout={'fixed'}
                  width={56}
                  height={20}
                  src={Consts.W3cValidatorSvg}
                  alt="w3c"
                />
              </a> */}
              {/* <form id="ackecker_form" target="_blank" method="post"
                action="https://achecker.achecks.ca/checker/index.php" style={{ display: 'inline-block' }}
                className="ng-pristine ng-valid">
                <input type="hidden" name="uri" id="checkuri" value="window.location}"/>
                <a id={'wcag_form_submit'} href={'https://achecks.org/checker/index.php'} aria-labelledby={'ackecker_form'} target="_blank" rel="noreferrer" title={'wcag_form_submit'} style={{ width: 56, height: 20 }}>
                  <Image
                    layout={'fixed'}
                    width={56}
                    height={20}
                    src={Consts.WcagValidatorSvg}
                    alt="wcag"
                  />
                </a>
              </form> */}
            </div>
          </div>
          {
            props.hasLoggiaBadge ?
              <div className={'row justify-content-center text-center py-3'}>
                <a href="https://revplus.com/" target="_blank" aria-label="Powered by revplus"
                  title="Powered by revplus" rel="noreferrer" className="w-auto">
                  <LoggiaSVGNew footerClass={props.footerClass}/>
                </a>
              </div>
              :''
          }
        </div>
      </div>
    </footer>
  )
}
